import { render, staticRenderFns } from "./page-history.vue?vue&type=template&id=6e782e5c&"
import script from "./page-history.vue?vue&type=script&lang=js&"
export * from "./page-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports